import React from 'react';

import { FilterField, SortField } from '../../../../components/Table';
import { NavLink } from 'react-router-dom';

const Component = ({ list, total, filters, sort, handlers }) => (
  <div className="col-md-6">
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title">App (<b className="text-info">{list.length} : {total}</b>)</h5>
          <div>
            <NavLink className="btn btn-round btn-info" to={`/app/add`}>
              <i className="nc-icon nc-simple-add"/>
            </NavLink>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-small">
            <thead className="text-primary">
              <tr>
                <SortField className="col-auto text-left" name="version" label="Version" sort={sort} handlers={handlers} />
                <SortField className="col-auto text-center" name="created" label="Created" sort={sort} handlers={handlers} />
              </tr>
              <tr>
                <FilterField name="version" filters={filters} handlers={handlers} />
                <th />
              </tr>
            </thead>
            <tbody>
            {list && list.map((data, idx) => (
              <tr key={idx}>
                <td className="text-right pr-3">{data.version}</td>
                <td className="text-center text-nowrap">{data.created}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default Component;
